import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';

import { L10n } from '@syncfusion/ej2-base';
import { FilterService, MessageService } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { Query, DataManager } from '@syncfusion/ej2-data';
import { v4 as uuidv4 } from 'uuid';
import { TabComponent } from '@syncfusion/ej2-angular-navigations';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-rule-edit',
  templateUrl: './rule-edit.component.html',
  styleUrls: ['./rule-edit.component.css'],
  providers: [FilterService,MessageService],

})
export class RuleEditComponent implements OnInit {
  @ViewChild('maintable') maintable:any;
  @ViewChild('filter') filter!: ElementRef;


  tipimonitorList=[
   "", 'Portineria','Interno','Ad uso dipendenti'
  ];
  toolbar:any=[];


  action='';
  elencoPlayList:any[]=[];
  elencomonitorList:any[]=[];
  selectedMOnitors:any[]=[];
  hoursList=[
    "00","02","02","03","04","05","06","07","08","09","10","11","12",
    "13","14","15","16","17","18","19","20","21","22","23"
  ]
  minutesList=[
    "00","10","20","30","40","50"
  ]
  rule:any;


  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public router: Router,
  ) { }


  ngOnInit(): void {
    this.toolbar = ['Search'];
    this.action=this.route.snapshot.paramMap.get('action');
    this.rule={
      nome:'',
      descrizione:'',
      attiva: true,
      tipo_monitor:'',
      playlist_id:0,
      playlist1_id:0,
      playlist2_id:0,
      from_hours:"00",
      from_minutes:"00",
      to_hours:"23",
      to_minutes:"50",
      from:null,
      to:null,
      monitors:[]
    }
  
  this.apiService.post('kodi/monitorslistall',{}).subscribe(data2 => {
  this.elencomonitorList=data2.Result; 
  });

  this.apiService.post('kodi/playlistslistall',{}).subscribe(data2 => {
    this.elencoPlayList=[];
    this.elencoPlayList.push({
        id:0,
        nome:'nessuna playlist'
    });
    data2.Result.forEach((p)=>{
      this.elencoPlayList.push({
          id:p.id,
          nome:p.nome
      });
    });
  });

    if(this.route.snapshot.paramMap.get('id')){
      this.apiService.post('kodi/ruleslistall',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
        this.rule=data2.Result[0];
        this.rule.attiva = !(this.rule.attiva === false || this.rule.attiva === 0 || this.rule.attiva === '0');
        if(this.rule.from){
          this.rule.from=new Date(this.rule.from);
        }
        if(this.rule.to){
          this.rule.to=new Date(this.rule.to);
        }
        if(!this.rule.monitors){
          this.rule.monitors=[];
        }
      });
    }

  }

  salva(){
    const payload = {
      ...this.rule,
      attiva: this.rule.attiva ? 1 : 0,
    };
    this.apiService.post('kodi/updaterule', payload).subscribe(data => {
      this.addSingle('success', 'Successo', 'Regola salvata');
      setTimeout(()=>{
        this.router.navigate(['/dashboard/monitors/rules']);
      },1500);

    });

  }
  
  onGlobalFilter(table: Table, event: Event) {
      table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }
  
  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  cannotSave(){
   
    if(this.rule.nome==''){
      return true;
    }
    
    if(!this.rule.playlist_id || this.rule.playlist_id==0){
      return true;
    }
   
    if(!this.rule.from || this.rule.from==''){
      return true;
    }

   
    if(!this.rule.to || this.rule.to==''){
      return true;
    }
   
    let d1=new Date(this.rule.from);
    let d2=new Date(this.rule.to);
    let now=new Date();
    if(d1.getTime()>d2.getTime()){
         return true;
    }
    
    if(now.getTime()>d2.getTime()){
         return true;
    }

    return false;

  }
}

